import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";

export const hpItemsStudent = [
  {
    title: "Öva på högskoleprovet med AI",
    description:
      "Öva på högskoleprovet med AI som stöd. Starta en konversation när du vill om frågan du undrar om för att öka förståelsen.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/hp.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/hp.png",
    icon: "School",
    path: "/app/hogskoleprov",
    listItems: [
      {
        text: "Öva på förra årets högskoleprov eller specifika delar ",
      },
      {
        text: "Praktisk vy över dina aktiva prov så du enkelt kan skifta",
      },
      {
        text: "Diskutera med vår AI när som helst för att öka din förståelse",
      },
      {
        text: "Använd tangentbordet för smidig navigering",
      },

      {
        text: "Smidig översikt över samtliga frågor så du enkelt kan hoppa fram och tillbaka",
      },

      {
        text: "Vi arbetar på att lägga in flera gamla högskoleprov! :)",
      },
    ],
  },
];

export const podcastItemsStudent = [
  {
    title: "Generera podcast",
    description:
      "Generera en podcast baserat på valfritt dokument, bild, URL eller egna instruktioner. Ladda ned eller dela.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/podcast-generera-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/podcast-generera.png",
    icon: "Mic",
    path: "/app/podcast",
    listItems: [
      { text: "Generera en podcast om vilket ämne du vill" },
      {
        text: "Basera podcasten på valfritt dokument, bild, URL eller egna instruktioner",
      },
      {
        text: "Dela podcasten med vänner, ladda ned mp3-filen eller dela en länk",
      },
      {
        text: "Transkriptionen sparas så man kan läsa medan man lyssnar",
      },
      {
        text: "Generera din podcast på 50 olika språk",
      },
    ],
  },

  {
    title: "Dela podcast",
    description:
      "Möjlighet att dela podcasten via en delbar länk eller till dina vänner.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/podcast-dela-med-vanner.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/podcast-dela-med-vanner.png",
    icon: "Share",

    listItems: [
      { text: "Dela podcasten med dina vänner, enkelt och smidigt" },
      {
        text: "Dela podcasten via en delbar länk, åtkomlig för alla",
      },
    ],
  },
];

export const bibleItems = [
  {
    title: "Chatta med Bibeln",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibeln-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibeln-2.png",
    icon: "LibraryBooks",

    listItems: [
      {
        text: "Interaktiv dialog med bibeln innehåll – ställ frågor och få svar som om du chattar direkt med bibeln",
      },
      {
        text: "Avancerad semantisk sökning identifierar de mest relevanta textavsnitten från originalkällan",
      },
      {
        text: "Vår AI förstår bibeltextens djupare innebörd och mening",
      },
      // {
      //   text: "Utforska komplexa ämnen genom att ställa följdfrågor – precis som i en verklig dialog",
      // },
      {
        text: "Upptäck insikter och information som annars kan vara svåra att hitta genom traditionell läsning",
      },
    ],
  },

  {
    title: "Anpassa hur assistenten svarar",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bibel-anpassa-prompt.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bibel-anpassa-prompt.png",
    icon: "Edit",

    listItems: [
      {
        text: "Redigera precis hur du vill att assistenten svarar",
      },
      {
        text: "Beskriv vilket format du vill ha, längden på svar, komplexitetsnivå etc.",
      },
      {
        text: "Total kontroll",
      },
    ],
  },

  {
    title: "Exportera innehåll",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibel-tabell.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibel-tabell.png",
    icon: "Download",

    listItems: [
      {
        text: "Fråga AI-modellen efter ett svar i tabell-format",
      },
      {
        text: "Exportera som Word- eller PDF-fil",
      },
      {
        text: "Redigera i efterhand vid behov",
      },
    ],
  },

  {
    title: "Spara meddelanden i eget arkiv",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibel-spara.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibel-spara.png",
    icon: "SaveAs",

    listItems: [
      {
        text: "Du kan när som helst spara viktiga meddelanden",
      },
      {
        text: "Tillgång till eget arkiv",
      },
      {
        text: "Utmärkt för att samla meddelanden till ett visst projekt",
      },
    ],
  },
];

export const imageItemsStudent = [
  {
    title: "Bildanalys",
    description:
      "Ladda upp valfri bild och få en analys. Populärt bland elever & studenter som tar bilder på matematiska formler, eller svåra förklaringar, och får en förenklad förklaring.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bildanalys.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bildanalys.png",
    icon: "AutoFixHigh",

    listItems: [
      { text: "Ladda upp valfri bild och få en analys" },
      {
        text: "Populärt bland elever & studenter som tar bilder på matematiska formler och får en förklaring",
      },
      {
        text: "Möjlighet att själv instruera vad som ska analyseras i bilden och hur informationen ska presenteras",
      },
    ],
  },
  {
    title: "Generera bilder med AI",
    description:
      "Beskriv vad du vill generera och få en AI-genererad bild som sparas i ditt eget arkiv, eller ladda ned/skriv ut direkt.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/generera-bilder.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/generera-bilder.png",
    icon: "AutoFixHigh",

    listItems: [
      { text: "Beskriv vad du vill generera för bild" },
      { text: "Bilden sparas i ditt eget arkiv" },
      { text: "Ladda ned bilden och använd hur du vill" },
      { text: "Möjlighet att skriva ut bilden direkt" },
    ],
  },
];

export const lessonPlanItems = [
  {
    title: "Generera lektionsplanering",
    description:
      "Generera en lektionsplanering på 1 minut och redigera, skriv ut, dela med elever/kollegor eller spara i din egen lektionsbank.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/generera-lektionsplanering-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/generera-lektionsplanering.png",
    icon: "AutoFixHigh",
    listItems: [
      { text: "Generera en lektionsplanering om exakt vad du vill" },
      { text: "Välj årskurs och längd på lektionen" },
      { text: "Redigera vid behov" },
      { text: "Lägg till egna eller AI-genererade bilder" },
      { text: "Skriv ut eller spara i din egen lektionsbank" },
      { text: "Gå tillbaka när som helst för att göra ändringar" },
    ],
  },

  {
    title: "Redigera lektionsplanering",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/redigera-lektionsplanering.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/redigera-lektionsplanering.png",
    icon: "Edit",
    listItems: [
      { text: "Redigera lektionsplaneringen efter behov" },
      { text: "Ta bort delar som inte behövs" },
      { text: "Spara ändringarna" },
    ],
  },

  {
    title: "Spara i egen lektionsbank",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/spara-lektionsplanering.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/spara-lektionsplanering.png",
    icon: "SaveAs",
    listItems: [
      { text: "Spara lektionsplaneringar i din egen lektionsbank" },
      { text: "Kategorisera utifrån ämne och årskurs" },
      {
        text: "Möjlighet att gå tillbaka när som helst för att göra ändringar",
      },
      { text: "Redigera en gammal lektionsplanering när du vill" },
    ],
  },

  {
    title: "Skriv ut lektionsplanering",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/skriv-ut-lektionsplanering.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/skriv-ut-lektionsplanering.png",
    icon: "Print",
    listItems: [
      { text: "Skriv ut lektionsplaneringen" },
      {
        text: "Märker du att nåt blev fel — gå tillbaka och redigera och skriv ut igen",
      },
      {
        text: "Möjlighet att skriva ut gamla lektionsplaneringar från din lektionsbank när som helst",
      },
    ],
  },
];

export const lessonItems = [
  {
    title: "Generera lektioner",
    description:
      "Se hur du enkelt genererar en lektion med tillhörande bilder. Sparar i din egen lektionsbank och skriver ut.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/generera-lektioner.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/generera-lektioner.png",
    icon: "AutoFixHigh",
    listItems: [
      { text: "30 lektionstyper (läsförståelse. escape rooms m.fl.)" },
      { text: "Generera lektioner från valfritt underlag" },
      { text: "Redigera material efter behov" },
      { text: "Generera passande bilder" },
      { text: "Dela med elever" },
      { text: "Spara i lektionsbank eller skriv ut" },
    ],
  },

  {
    title: "Generera övningar",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-ovningar.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/lektioner-ovningar.png",
    icon: "Spellcheck",
    listItems: [
      { text: "Komplettera lektionen genom att generera övningar" },
      { text: "Välj mellan 6 olika övningstyper" },
      { text: "Redigera vid behov" },
      { text: "Lägg till övningarna i din lektion" },
      { text: "Spara lektionen, skriv ut eller dela med elever" },
    ],
  },

  {
    title: "Generera frågor",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/lektioner-quiz.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/lektioner-quiz.png",
    icon: "Psychology",
    listItems: [
      { text: "Komplettera lektionen genom att generera frågor/quiz/prov" },
      {
        text: "Välj mellan 4 olika frågetyper (flervalsfrågor, sant/falskt m.fl.)",
      },
      { text: "Redigera eller lägg till frågor vid behov" },
      { text: "Lägg till frågorna i din lektion" },
      { text: "Spara lektionen, skriv ut eller dela med elever" },
      { text: "Tillgång till facit på separat sida vid utskrift" },
    ],
  },

  {
    title: "Generera tidslinje",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/lektioner-tidslinje.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/lektioner-tidslinje.png",
    icon: "Timeline",
    listItems: [
      { text: "Komplettera lektionen genom att generera en tidslinje" },
      {
        text: "Välj antal händelser och språk för tidslinjen",
      },
      {
        text: "Redigera händelserna, dess ordning, bilder eller och text vid behov",
      },
      { text: "Lägg till tidslinjen i din lektion" },
      { text: "Spara lektionen, skriv ut eller dela med elever" },
    ],
  },

  {
    title: "Redigera lektioner",
    description:
      "Anpassa dina genererade lektioner efter dina behov. Lägg till, ta bort eller modifiera innehåll för att skapa den perfekta lektionen för din klass.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/redigera-lektioner.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/redigera-lektioner.png",
    icon: "Edit",
    listItems: [
      { text: "Allt som genereras kan redigeras" },
      { text: "Anpassa innehållet utifrån elevens behov" },
      {
        text: "Glöm inte att spara lektionen i din lektionsbank efter ändringarna är gjorda",
      },
    ],
  },

  {
    title: "Spara i din egen lektionsbank",
    description:
      "Du kan enkelt spara dina egna eller andras lektioner i din egen lektionsbank och gå tillbaka och redigera när som helst. Du kan även kategorisera lektionerna utifrån ämne och årskurs vilket gör dem enklare att hitta.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/spara-i-lektionsbank.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/spara-i-lektionsbank-poster.png",
    icon: "SaveAs",
    listItems: [
      { text: "Tillgång till personligt arkiv" },
      { text: "Kategorisera dina lektioner utifrån ämne och årskurs" },
      { text: "Gå tillbaka och redigera tidigare lektioner när som helst" },
      { text: "Radera lektioner när du vill" },
    ],
  },

  {
    title: "Dela via elevrum (konto krävs)",
    description:
      "Dela dina lektioner med elever eller kollegor. De får en avisering och kan enkelt gå in i lektionen samt hitta den under 'Mitt innehåll'.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/share-lesson.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/share-lesson-poster.png",
    icon: "Share",
    listItems: [
      { text: "Dela lektioner med alla eller några elever i ett elevrum" },
      { text: "Eleven får en avisering när lektionen är delad" },
    ],
  },

  {
    title: "Dela via länk (inget konto krävs)",
    description:
      "Dela dina lektioner med elever eller kollegor. De får en avisering och kan enkelt gå in i lektionen samt hitta den under 'Mitt innehåll'.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/dela-lank-till-lektioner.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/dela-lank-till-lektioner.png",
    icon: "Link",
    listItems: [
      { text: "Välj en av dina sparade lektioner" },
      { text: "Klicka på dela länk" },
      { text: "Kopiera länken och dela den via Google Classroom eller e-post" },
      { text: "Inget konto för elever krävs" },
    ],
  },
  {
    title: "Översätt",
    description:
      "Översätt ditt lektionsmaterial till olika språk med ett enkelt knapptryck. Perfekt för flerspråkiga klassrum eller språkundervisning.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/oversatt.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/oversatt-poster.png",
    icon: "Translate",
    listItems: [
      { text: "Översätt lektioner på över 50 språk" },
      { text: "Utmärkt för elever som inte behärskar svenska fullt ut" },
      { text: "Alla elever känner sig inkluderade" },
    ],
  },
];

export const quizItemsStudent = [
  {
    title: "Generera quiz",
    description:
      "Generera interaktivt quiz som är populärt bland elever och studenter. Se resultat och hur du hittar dina genererade quiz under 'Mitt innehåll' varifrån man kan dela, redigera eller radera.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/generera-quiz-2.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/generera-quiz-2.png",
    icon: "Gamepad",
    listItems: [
      { text: "Generera interaktivt quiz baserat på valfritt underlag" },
      { text: "Utmärkt för elever & studenter som vill öva inför ett prov" },
      {
        text: "Välj mella flera frågetyper (prov, flervalsfrågor etc.)",
      },
      { text: "Tillgång till eget arkiv" },
      { text: "Graf med resultat över tid" },
    ],
  },

  {
    title: "Diskutera med AI",
    description:
      "Du kan närsomhelst diksutera med AI beträffande frågan för att öka din förståelse.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-fraga-ai.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-fraga-ai.png",
    icon: "ChatBubbleOutline",
    listItems: [
      { text: "Diskutera med vår AI-modell för att lösa frågan" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },

  {
    title: "Ledtrådar från AI",
    description:
      "Få en eller flera ledtrådar som stegvis leder dig fram till förståelse och en lösning.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-ledtrad.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-ledtrad.png",
    icon: "Lightbulb",
    listItems: [
      { text: "Få en ledtråd från vår AI-modell för att lösa frågan" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },

  {
    title: "Dela med vänner",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-dela-med-vanner.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/quiz-dela-med-vanner.png",
    icon: "Share",
    listItems: [
      { text: "Dela valfria quiz med dina vänner" },
      { text: "Din vän får en avisering och kan börja öva när som helst" },
      { text: 'Quizzet sparas i "Delat med mig"' },
    ],
  },

  {
    title: "Välj mellan olika underlag",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/underlag.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/underlag.png",
    icon: "HighlightAlt",
    listItems: [
      { text: "Skriv in egna instruktioner" },
      { text: "Klistra in valfri text" },
      {
        text: "Ladda upp valfritt studiematerial",
      },
      { text: "Hämta innehåll från valfri webbaddress" },
      {
        text: "Ladda upp en bild, analysera dess innehåll och använd dett som underlag",
      },
      { text: "Samt många fler alterantiv" },
    ],
  },

  {
    title: "Redigera quiz",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-redigera.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-redigera.png",
    icon: "Edit",
    listItems: [
      { text: "Redigera valfritt quiz enkelt och smidigt" },
      { text: "Lägg till eller ta bort frågor" },
      { text: "Anpassa svarsalterantiv och ledtrådar" },
      { text: "Spara ändringarna" },
    ],
  },
  {
    title: "Skriftliga prov",
    description:
      "Generera ett quiz som kräver resonerande svar. Populärt bland elever och studenter som använder det för att förbereda sig inför ett riktigt prov.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/quiz-generera-resonerande-prov-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/quiz-resonerande-prov.png",
    icon: "Psychology",
    listItems: [
      { text: "Generera quiz som kräver resonerande svar" },
      { text: "Populärt bland elever & studenter som övning inför prov" },
      {
        text: "AI:n bedömer varje svar och ger utförlig förklaring för varje svar",
      },
      { text: "Välj bland 3 ljudeffekter för att simulera en provmiljö" },
      { text: "Möjlighet att som lärare se resultaten i realtid" },
    ],
  },

  {
    title: "Öva under tidspress med timer",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-timer.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-timer.png",
    icon: "Timer",
    listItems: [
      { text: "Simulera en provmijö genom att aktivera en timer" },
      { text: "Välj hur många sekunder man ska få för varje fråga" },
      { text: "Utmärkt för att öva inför en provsituation" },
    ],
  },

  {
    title: "Simulera prov med bakgrundsljud",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/quiz-ljudeffekt.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/quiz-ljudeffekt.png",
    icon: "VolumeUp",
    listItems: [
      { text: "Öva på provet genom att aktivera bakgrundsljud" },
      {
        text: "Välj mellan 3 olika ljudeffekter: väggklocka, cafésorl och klotter",
      },
      { text: "Perfekt för att öva på att resonera med bakgrundsljud" },
    ],
  },
];

export const flashcardItemsStudent = [
  {
    title: "Generera flashcards",
    description:
      "Generera interaktiva flashcards. Redigera och lägg till bilder för varje flashcard om du vill. Öva när som helst.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/generera-interaktiva-flashcards-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/generera-interaktiva-flashcards-2.png",
    icon: "Gamepad",

    listItems: [
      {
        text: "Generera flashcards baserat på valfritt underlag eller instruktioner",
      },
      {
        text: "Redigera vid behov",
      },
      {
        text: "Lägg till bilder för framsida eller baksida om du föredrar visuellt lärande",
      },
      {
        text: "Bedöm svårighetsgraden för varje flashcard med tangentbordsgenvägar (1, 2, 3, 4 & mellanslag)",
      },
      {
        text: "Sparas i Mina flashcards så du när som helst kan öva igen",
      },
    ],
  },

  {
    title: "Diskutera med AI",
    description:
      "Du kan närsomhelst diksutera med AI beträffande dina flashcards för att öka din förståelse.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/flashcards-fraga-ai.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/flashcards-fraga-ai.png",
    icon: "ChatBubbleOutline",
    listItems: [
      { text: "Diskutera med vår AI-modell" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },

  {
    title: "Ledtrådar från AI",
    description:
      "Få en eller flera ledtrådar som stegvis leder dig fram till förståelse och en lösning.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/flashcards-ledtrad.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/flashcards-ledtrad.png",
    icon: "Lightbulb",
    listItems: [
      { text: "Få en ledtråd från vår AI-modell" },
      { text: "Ställ följdfrågor för ytterligare förståelse" },
      {
        text: "Välj mellan fördefinierade prompts för snabbare kommunikation",
      },
    ],
  },

  {
    title: "Dela med vänner",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/flashcards-dela-med-vanner.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/flashcards-dela-med-vanner.png",
    icon: "Share",
    listItems: [
      { text: "Dela valfria flashcards med dina vänner" },
      { text: "Din vän får en avisering och kan börja öva när som helst" },
      { text: 'Flashcards sparas i "Delat med mig"' },
    ],
  },

  {
    title: "Välj mellan olika underlag",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/underlag.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/underlag.png",
    icon: "HighlightAlt",
    listItems: [
      { text: "Skriv in egna instruktioner" },
      { text: "Klistra in valfri text" },
      {
        text: "Ladda upp valfritt studiematerial",
      },
      { text: "Hämta innehåll från valfri webbaddress" },
      {
        text: "Ladda upp en bild, analysera dess innehåll och använd dett som underlag",
      },
      { text: "Samt många fler alterantiv" },
    ],
  },

  {
    title: "Redigera flashcards",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/redigera-flashcards.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/redigera-flashcards.png",
    icon: "Edit",

    listItems: [
      { text: "Gå till Mina flashcards" },
      { text: "Klicka på Redigera, gör dina ändringar och spara" },
      {
        text: "Utmärkt för att göra ändringar i efterhand utan att behöva generera nya",
      },
      { text: "Dela med elever ånyo" },
    ],
  },
];

export const textLabbetItems = [
  {
    title: "Hur textlabbet fungerar",
    description:
      "Se hur du kan manipulera vilken text som helst. Analysera, kritisera, omstrukturera, översätta samt 30 andra alterantiv.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/textlabbet.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/textlabbet-poster.png",
    icon: "AutoFixHigh",
  },
];

export const gradingItemsStudent = [
  {
    title: "Bedöm din text",
    description:
      "Se hur du bedömer din text och får övergripande betyg, poäng per bedömningskriterium samt en detaljerad analys.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomning-bedom-din-text.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bedomning-bedom-din-text.png",
    icon: "AutoFixHigh",
    listItems: [
      { text: "Bedöm valfri text objekivt och konsekvent" },
      { text: "Få ett övergripande betyg & poäng per bedömningskriterium" },
      { text: "Detaljerad analys av texten" },
      { text: "Välj bland fördefinierade bedömningsmatriser eller egna" },

      { text: "Generera egna bedömningsmatriser" },
    ],
  },

  {
    title: "Generera bedömningsmatris",
    description:
      "Se hur du genererar en bedömningsmatris baserat på dina egna behov. Redigera vid behov och spara till ditt eget arkiv. ",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/bedomningsmatris-generera-med-ai.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/bedomningsmatris-generera-med-ai.png",
    icon: "TableChart",
    listItems: [
      { text: "Bedöm texter baserat på egenskapade bedömningsmatriser" },
      { text: "Redigera matriser utifrån behov" },

      { text: "Tillgång till eget arkiv" },
    ],
  },
];

export const powerpointItems = [
  {
    title: "Generera PowerPoint",
    description: "Se hur du genererar en PowerPoint med tillhörande bilder.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/generera-powerpoint-3.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/powerpoint-poster.png",
    icon: "AutoFixHigh",

    listItems: [
      {
        text: "Generera en PowerPoint utifrån valfritt ämne eller underlag",
      },
      {
        text: "Redigera text vid behov",
      },
      {
        text: "Lägg till egna eller AI-genererade bilder",
      },
      {
        text: "Exportera PowerPoint",
      },
      {
        text: "Spara i ditt eget arkiv och redigera när som helst",
      },
    ],
  },
];

export const assistentItemsStudent = [
  {
    title: "Träna din egen AI-assistent",
    description:
      "Träna din egen AI-assistent baserat på valfritt underlag. Ladda upp eller klistra in ditt material och få tillgång till en assistent som använder avancerad semantisk förståelse för att tolka både ditt material och dina frågor. ",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/assistent-trana.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/assistent-trana.png",
    icon: "AutoFixHigh",
    path: "/app/larare",
    listItems: [
      {
        text: "Definiera vilket material assistenten ska tränas på",
      },
      {
        text: "När du ställer en fråga genomförs en semantisk sökning som identifierar de mest relevanta textavsnitten från originalkällan",
      },
      {
        text: "Assistenten analyserar sedan texten och formulerar ett svar som är direkt baserat på kunskapsbasen",
      },
      { text: "Tillgång till historik över ens chattar" },
      { text: "Möjlighet att spara meddelanden" },
    ],
  },
  {
    title: "Språk-assistenter",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/assistent-sprak-spanska.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/assistent-sprak-spanska.png",
    icon: "Language",

    listItems: [
      {
        text: "Chatta eller tala med valfri Språk-assistent för att öva på språkfärdigheterna",
      },
      {
        text: "Välj att öva på olika rollspel (t.ex. besök på restaurang, eller boka en taxi)",
      },

      {
        text: "Öva på läsförståelse, verb och mycket mer",
      },
      {
        text: "Få en rapport med förbättringsförslag och felstavningar",
      },

      {
        text: "Möjlighet att dela konversationen",
      },
      {
        text: "Tillgång till konversationshistorik",
      },
      {
        text: "Exportera, spara, kopiera eller översätt meddelanden",
      },
    ],
  },

  {
    title: "Ämnes-assistenter",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/assistent-matte.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/assistent-matte.png",
    icon: "School",

    listItems: [
      {
        text: "Chatta eller tala med valfri Ämnes-assistent inom t.ex. Matematik, Historia & Samhällskunskap",
      },
      {
        text: "Möjlighet att dela konversationen",
      },
      {
        text: "Tillgång till konversationshistorik",
      },
      {
        text: "Exportera, spara eller kopiera meddelanden",
      },
    ],
  },

  {
    title: "Chatta med böcker",
    description: "",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bibeln.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bibeln.png",
    icon: "LibraryBooks",

    listItems: [
      {
        text: "Avancerad semantisk sökning identifierar de mest relevanta textavsnitten från originalkällan",
      },
      {
        text: "Interaktiv dialog med bokens innehåll – ställ frågor och få svar som om du chattar direkt med boken",
      },

      {
        text: "Alla svar är direkt förankrade i bokens faktiska innehåll",
      },
      {
        text: "Utforska komplexa ämnen genom att ställa följdfrågor – precis som i en verklig dialog",
      },
      {
        text: "Få välgrundade svar inom bokens ämnesområde med direkta kopplingar till originalverket",
      },
      {
        text: "Upptäck insikter och information som annars kan vara svåra att hitta genom traditionell läsning",
      },
    ],
  },

  {
    title: "ChatGPT för elever",
    description: "",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/assistent-chatgpt.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/assistent-chatgpt.png",
    icon: "Chat",

    listItems: [
      {
        text: "Vår egen version av ChatGPT för elever",
      },
      {
        text: "Välj vilket språk den ska kommunicera med dig på (över 50 språk)",
      },
      {
        text: "Möjlighet att exportera, spara, kopiera & läsa upp meddelanden",
      },
      {
        text: "Tillgång till konversationshistorik",
      },
      {
        text: "Fördefinierade prompts som t.ex. att skapa begreppslistor & grupparbete",
      },
      {
        text: "Skapa helt egna prompts för att snabba upp ditt arbete",
      },
    ],
  },

  {
    title: "Skapa en AI-assistent",
    description:
      "Se hur du skapar en AI-assistent och hur man kan dela konversationer med andra.",
    videoUrl:
      "https://sportkuriren.se/wp-content/uploads/skapa-assistent-2.mp4",
    poster:
      "https://sportkuriren.se/wp-content/uploads/generera-ai-assistent.png",
    icon: "AutoFixHigh",

    listItems: [
      {
        text: "Definiera exakt hur assistenten ska bete sig och vad den får tala om",
      },
      { text: "Redigera & finjustera karaktärens egenskaper direkt i chatten" },

      { text: "Tillgång till historik över ens chattar" },
      { text: "Möjlighet att spara meddelanden" },
    ],
  },
];

export const visionItems = [
  {
    title: "Bildanalys",
    description:
      "Ladda upp valfri bild och få en analys. Populärt bland elever & studenter som tar bilder på matematiska formler, eller svåra förklaringar, och får en förenklad förklaring.",
    videoUrl: "https://sportkuriren.se/wp-content/uploads/bildanalys.mp4",
    poster: "https://sportkuriren.se/wp-content/uploads/bildanalys.png",
    icon: "AutoFixHigh",
    listItems: [
      { text: "Ladda upp valfri bild och få en analys" },
      {
        text: "Populärt bland elever & studenter som tar bilder på matematiska formler och får en förklaring",
      },
      {
        text: "Möjlighet att själv instruera vad som ska analyseras i bilden och hur informationen ska presenteras",
      },
    ],
  },
];

export const VideoPlayer = ({
  videoUrl,
  poster,
  controls = false,
  autoPlay = false,
}) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleClick = (e) => {
    // Only handle click for play/pause when controls aren't enabled
    if (controls) return;

    e.preventDefault();
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.playbackRate = 1.25;
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        cursor: controls ? "default" : "pointer",
      }}
      onClick={handleClick}
    >
      <Box
        component="video"
        ref={videoRef}
        loop
        muted
        preload="auto"
        poster={poster}
        src={videoUrl}
        playsInline={true}
        controls={controls}
        autoPlay={autoPlay}
        alt="Instruktionsvideo"
        sx={{
          width: "100%",
          height: "auto",
          borderRadius: "15px",
          display: "block",
          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
        }}
      />
      {!controls && (
        <Box
          className="play-button"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "rgb(0 0 0 / 83%)",
            display: isPlaying ? "none" : "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "transform 0.2s",
            pointerEvents: "none",
            "&:hover": {
              transform: "translate(-50%, -50%) scale(1.1)",
            },
          }}
        >
          <PlayArrowIcon sx={{ color: "white", fontSize: "4rem" }} />
        </Box>
      )}
    </Box>
  );
};
